<template>
  <div class="product-details-content-draggable-items">
    <draggable
      :value="value"
      @input="val => $emit('input', val)"
      handle=".handle"
      class="draggable-list"
      :group="group"
    >
      <div
        v-for="(item, index) in value"
        class="position-relative"
        :key="index"
      >
        <draggable-submodules-item
          v-if="item.type == 'submodule' || item.parent"
          :module="item"
          is-submodule
          @edit="subItem => $emit('edit', subItem)"
          @duplicate="subItem => $emit('duplicate', subItem)"
          @remove="subItem => $emit('remove', subItem)"
        />
        <div
          v-else
          class="w-100 card"
          :class="{ indicator: showListIndicator }"
        >
          <div class="draggable-item-body">
            <div class="d-flex align-items-center text-truncate flex-fill">
              <i class="ph ph-dots-six-vertical handle lead pr-2" />
              <div class="d-flex align-items-center gap-2">
                <span
                  :contenteditable="editname"
                  @click.stop="onEditName"
                  @blur="e => onBlurName(index, e, item)"
                  spellcheck="false"
                  class="name text-wrap text-left"
                >
                  {{ item.name }}
                </span>
                <i v-if="item.type == 'quiz'" class="ph ph-exam text-orange" />
                <span v-if="item.status === 'draft'" class="draft-badge">
                  Rascunho
                </span>
              </div>
            </div>
            <div class="draggable-item-buttons d-flex gap-2">
              <snow-button
                size="sm"
                text="Editar"
                variant="gray"
                @click="goToRoute(item)"
              />
              <snow-button
                v-if="item.type !== 'quiz'"
                size="sm"
                text="Duplicar"
                variant="gray"
                @click="$emit('duplicate', item)"
              />
              <snow-button
                size="sm"
                text="Excluir"
                variant="danger"
                @click="$emit('remove', item)"
              />
            </div>

            <!-- <actions-dropdown
              class="d-sm-none"
              :left="false"
              :right="true"
              :actions="getActions(item)"
              toggleClass="p-0"
              @edit="$emit('edit', item)"
              @duplicate="$emit('duplicate', item)"
              @remove="$emit('remove', item)"
            >
              <template #button-custom-content>
                <i class="icon-more-vertical btn btn-sm" role="button"></i>
              </template>
            </actions-dropdown> -->
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "draggable-items",
  components: {
    draggable,
    DraggableSubmodulesItem: () =>
      import("@/components/product/details/content/DraggableModulesItem.vue")
  },
  props: {
    value: Array,
    hideSubModules: Boolean,
    showListIndicator: Boolean,
    parent: {
      type: Object,
      default: () => {}
    },
    group: { type: String, default: "modules" }
  },
  data() {
    return {
      initialValue: this.value || [],
      loadingName: false,
      editname: false,
      collapsed: []
    };
  },
  methods: {
    getActions(item) {
      const target = item.type == "quiz" ? "avaliação" : "aula";
      return [
        {
          text: `Editar ${target}`,
          class: "",
          icon: "icon-filled-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        ...(item.type == "lesson"
          ? [
              {
                text: "Duplicar aula",
                class: "",
                icon: "icon-filled-clone",
                confirmation: {
                  enable: false
                },
                event: "duplicate"
              }
            ]
          : []),
        {
          text: `Excluir ${target}`,
          class: "text-danger",
          icon: "icon-filled-trash",
          confirmation: {
            enable: true,
            text: `Tem certeza que deseja excluir essa ${target}?`,
            newDesign: true,
            submitText: "Excluir",
            submitButtonClass: "btn-danger"
          },
          event: "remove"
        }
      ];
    },
    goToRoute(item) {
      if (this.editname) return;

      if (item.type == "quiz") {
        this.$router.push({
          name: "product-members-module-quizz-edit",
          params: {
            id: this.$route.params.id,
            module_id: this.parent.id,
            quizz_id: item.code
          }
        });
      }

      if (item.type == "lesson") {
        this.$router.push({
          name: "product-members-lesson-edit",
          params: {
            id: this.$route.params.id,
            lesson: item.id
          }
        });
      }

      return {};
    },
    onKeyDownName(e) {
      if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        this.editname = false;
        return false;
      }
    },
    onEditName() {
      this.editname = true;
      document.addEventListener("keydown", this.onKeyDownName);
    },
    onBlurName(index, e, item) {
      if (this.loadingName) return;

      let validation_map = {
        quiz: "O nome da avaliação não deve ter mais de 64 caracteres",
        lesson: "O nome da aula não deve ter mais de 240 caracteres"
      };

      let translated_type = item.type == "quiz" ? "avaliação" : "aula";

      if (!e.target.innerText.trim().length) {
        e.target.innerText = this.initialValue[index].name;
        this.$message.error(`O nome da ${translated_type} não pode ser vazio`);
      } else if (
        (item.type == "quiz" && e.target.innerText.length > 64) ||
        (item.type == "lesson" && e.target.innerText.length > 240)
      ) {
        e.target.innerText = this.initialValue[index].name;
        this.$message.error(validation_map[item.type]);
      } else {
        const action =
          item.type == "quiz" ? "membersQuizzes/put" : "membersLessons/put";
        let param = item.type == "quiz" ? "title" : "name";
        let params = { ...item, [param]: e.target.innerText };
        this.loadingName = true;
        this.$store
          .dispatch(action, params)
          .then(() => {
            this.initialValue[index].name = e.target.innerText;
            this.$message.success(
              `O novo nome da ${translated_type} foi salvo`
            );
          })
          .catch(error => {
            this.$message.error(error.response.data[param][0]);
            e.target.innerText = this.initialValue[index].name;
          })
          .finally(() => {
            this.loadingName = false;
          });
      }
      this.editname = false;
      document.removeEventListener("keydown", this.onKeyDownName);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-details-content-draggable-items {
  .draggable-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .draggable-item-body {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    width: 100%;
  }

  .draggable-item-buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    padding-right: 8px !important;
  }

  a,
  a:hover {
    text-decoration: none;
  }
  .ph-dots-six-vertical {
    cursor: pointer;
    color: var(--dark-40);

    &:active {
      cursor: grap;
    }
  }

  .fa-file-pen {
    font-size: 14px;
  }

  .btn-link {
    padding: 0;
  }

  small {
    font-size: 10px;
    line-height: 12px;
    display: block;
    color: #888;
  }

  .card {
    border-radius: 16px;
    background: var(--bg-1);
    border: 1px solid var(--dark-10);
    position: relative;
  }

  .name {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
  }

  .icon-angle-down {
    font-size: 19px;
  }

  ::v-deep .btn-outline-dark {
    border: none;
    color: rgba(119, 120, 142, 0.87);
  }
}
</style>
